const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSCloudUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-cloud-up",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-cloud-up1",
    serifid: "iconS-cloud-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.93,20.25l-5.259,0c-3.109,0 -5.671,-2.451 -5.671,-5.523c0,-2.645 1.899,-4.834 4.413,-5.389c0.214,-1.295 1.047,-2.585 2.196,-3.575c1.499,-1.292 3.412,-2.007 5.391,-2.013c4.035,-0 7.385,2.998 7.749,6.869c2.388,0.337 4.251,2.337 4.251,4.79c-0,2.696 -2.247,4.841 -4.969,4.841l-5.961,0l-0,-7.343c-0,-0 1.804,1.805 1.804,1.805c0.2,0.201 0.473,0.314 0.757,0.314c0.588,0 1.071,-0.483 1.071,-1.071c0,-0.284 -0.113,-0.557 -0.314,-0.758l-3.631,-3.631c-0.2,-0.201 -0.473,-0.314 -0.757,-0.314c-0.284,0 -0.557,0.113 -0.758,0.315l-3.63,3.63c-0.201,0.201 -0.314,0.474 -0.314,0.758c-0,0.588 0.483,1.071 1.071,1.071c0.284,0 0.557,-0.113 0.757,-0.314l1.804,-1.805l0,7.343Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSCloudUp);
export default __webpack_public_path__ + "static/media/iconS-cloud-up.58c18e462b9690178566a3fca169d8ca.svg";
export { ForwardRef as ReactComponent };